import { Navigate } from 'react-router';

export default function ReferralIndex() {
  return <Navigate to="/referrals/active" replace />;
}
